import { useState } from 'react';
import { Typography, ConfirmationModal } from 'seagull';
import AccountantAccessLearnMoreButton from "../../../components/AccountantAccessLearnMoreButton";
import { useOverlayContext, useStoreActions } from "../../../contexts";
import { handlePromise } from "../../../infra/utils";
import styles from "../TeamPage.module.scss";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function AccountantAccessApprovalModal(props) {
  const {
    accountant,
    dismissModal,
    refresh
  } = props;
  const overlayContext = useOverlayContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const [rejectLoading, setRejectLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  async function submit(isApprove) {
    isApprove ? setApproveLoading(true) : setRejectLoading(true);
    const vendorId = accountant.id();
    logBI(isApprove ? 13101 : 13102, {
      vendorId,
      companyName: accountant.companyName()
    });
    const request = isApprove ? api.accountants.approveVendor : api.accountants.rejectVendor;
    const {
      success
    } = await handlePromise(request(vendorId));
    if (!success) {
      overlayContext.showErrorToast("Failed to ".concat(isApprove ? 'approve' : 'reject', " Accountant Access"), "acc-access-".concat(isApprove ? 'approve' : 'reject', "-failure"));
    } else {
      await refresh();
    }
    dismissModal();
  }
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    textAlignCenter: false,
    title: "Accountant Access request",
    primaryButtonLabel: "Approve",
    primaryButtonLoading: approveLoading,
    secondaryButtonLoading: rejectLoading,
    primaryButtonTestid: "approve-acc-access",
    secondaryButtonLabel: "Reject",
    secondaryButtonTestid: "reject-acc-access",
    onCloseButtonClick: () => dismissModal(),
    onPrimaryButtonClick: () => submit(true),
    onSecondaryButtonClick: () => submit(false),
    content: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Typography, {
        className: styles.paragraph,
        children: ["You have a pending Accountant Access request from ", accountant.companyName(), " from", ' ', accountant.invitedEmail(), "."]
      }), /*#__PURE__*/_jsxs(Typography, {
        className: styles.paragraph,
        children: ["Accountant Access will allow the ", accountant.companyName(), " team to view your account information on Anchor and manage your payment methods."]
      }), /*#__PURE__*/_jsx(Typography, {
        className: styles.paragraph,
        children: "You can remove their access at any point from your Team page."
      }), /*#__PURE__*/_jsx(AccountantAccessLearnMoreButton, {
        isVendor: false
      })]
    })
  });
}